import React from 'react';

export default function ErrorPanel({ error }) {
  if (!error) return null;
  return (
    <div className="p-4 bg-red-50 border border-red-200 rounded-2xl text-red-500 text-sm flex items-start gap-3">
      <span className="text-lg">⚠️</span>
      <p className="font-medium leading-relaxed">{error}</p>
    </div>
  );
}